import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
//@ts-ignore
import { FormLayout } from "@careinfo/layout";
import ReferenceTypeForm from "./ReferenceTypeForm";
import { productTypeValidationForm } from "../../utils/validationSchemas";

const CreateReferenceType = (props: any) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
  } = useForm<any>({
    resolver: yupResolver(productTypeValidationForm),
  });
  const { handleCreate, isLoading } = props;
  return (
    <FormLayout
      handleSubmit={handleSubmit}
      handleFormSubmit={handleCreate}
      setError={setError}
      buttonLabel={"Create"}
      isLoading={isLoading}
    >
      <ReferenceTypeForm
        errors={errors}
        register={register}
      />
    </FormLayout>
  );
};

export default CreateReferenceType;